import { render, staticRenderFns } from "./ReviewListsWithDragDrop.vue?vue&type=template&id=17fa280a&scoped=true&"
import script from "./ReviewListsWithDragDrop.vue?vue&type=script&lang=js&"
export * from "./ReviewListsWithDragDrop.vue?vue&type=script&lang=js&"
import style0 from "./ReviewListsWithDragDrop.vue?vue&type=style&index=0&id=17fa280a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fa280a",
  null
  
)

export default component.exports